export const ssnDefaultHelperText = 'Secured with SSL and 128-bit encryption.';
export const ssnDefaultLabel = 'Social Security Number';

export const nonDigitPattern = /\D/g;
export const digitPattern = /\d/;

export const getDigitsOnly = (value: string): string => value.replace(nonDigitPattern, '');

export const formatSsn = (digits: string): string => {
  if (digits.length <= 3) return digits;
  if (digits.length <= 5) return `${digits.slice(0, 3)}-${digits.slice(3)}`;

  return `${digits.slice(0, 3)}-${digits.slice(3, 5)}-${digits.slice(5)}`;
};

export const getDisplaySsnValue = (value: string): string => formatSsn(getDigitsOnly(value));

export type NextCursorPositionStateT = {
  nextCursorPosition: number;
  nextDigits: string;
};

export type GetNextCursorPositionT = (
  rawValue: string,
  selectionStart: number,
) => NextCursorPositionStateT;

export const getNextCursorPosition: GetNextCursorPositionT = (rawValue, selectionStart) => {
  const nextDigits = getDigitsOnly(rawValue);
  const digitsBeforeCursor = getDigitsOnly(rawValue.slice(0, selectionStart)).length;
  const formattedValue = formatSsn(nextDigits);

  const digitPositions = Array.from(formattedValue).reduce<number[]>(
    (positions, character, index) => (digitPattern.test(character) ? [...positions, index + 1] : positions),
    [],
  );

  return {
    nextCursorPosition: digitsBeforeCursor === 0
      ? 0
      : (digitPositions[digitsBeforeCursor - 1] ?? formattedValue.length),
    nextDigits,
  };
};
